import { DEFAULT_LOCALE, FALLBACK_LOCALE, MESSAGES } from './messages';

export { DEFAULT_LOCALE, FALLBACK_LOCALE };

/** 將 lang_code 對應到已載入的文案包 */
export function resolveLocale(langCode) {
  if (!langCode) {
    return DEFAULT_LOCALE;
  }
  const code = langCode.trim();
  if (MESSAGES[code]) {
    return code;
  }
  if (code === 'zh_HK') {
    return 'zh_TW';
  }
  const prefix = code.split('_')[0];
  const matched = Object.keys(MESSAGES).find((key) => key.startsWith(`${prefix}_`));
  return matched || FALLBACK_LOCALE;
}

function lookup(messages, key) {
  if (!messages || !key) {
    return undefined;
  }
  return key.split('.').reduce((node, part) => {
    if (node == null || typeof node !== 'object') {
      return undefined;
    }
    return node[part];
  }, messages);
}

/** 依語系與 key 取得文案；缺 key 時回退 en_US，再回退 key 本身 */
export function translate(langCode, key) {
  const locale = resolveLocale(langCode);
  const primary = lookup(MESSAGES[locale], key);
  if (typeof primary === 'string') {
    return primary;
  }
  const fallback = lookup(MESSAGES[FALLBACK_LOCALE], key);
  if (typeof fallback === 'string') {
    return fallback;
  }
  return key;
}
